import { animate, style, transition, trigger } from '@angular/animations';

// TODO: replace deprecated Angular animations with CSS animations
export const regularFontSizeAnimation = trigger('regularFontSizeAnimation', [
  transition(':enter', [style({ fontSize: 0 }), animate('0.5s ease-out', style({ fontSize: 16 }))]),
]);

// TODO: replace deprecated Angular animations with CSS animations
export const smallFontSizeAnimation = trigger('smallFontSizeAnimation', [
  transition(':enter', [style({ fontSize: 0 }), animate('0.4s ease-out', style({ fontSize: 12 }))]),
]);
